export default "__VITE_ASSET__CxZaznMw__"